import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const IMG1 = "https://images.unsplash.com/photo-1583394293214-28ded15ee548?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxjaGVmJTIwa2l0Y2hlbiUyMGF1dGhlbnRpYyUyMGFzaWFufGVufDB8fHx8MTc4MTQzNjc2NXww&ixlib=rb-4.1.0&q=85";
const IMG2 = "https://images.unsplash.com/photo-1610012370944-e822e8bb91c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxzcGljZXMlMjBmbGF0bGF5JTIwdHVybWVyaWMlMjBjaGlsaXxlbnwwfHx8fDE3ODE0MzY3NjV8MA&ixlib=rb-4.1.0&q=85";
const IMG3 = "https://images.unsplash.com/photo-1518732751612-2c0787ff5684?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxzdGVhbWVkJTIwZmlzaCUyMHJ1c3RpY3xlbnwwfHx8fDE3ODE0MzY3NjV8MA&ixlib=rb-4.1.0&q=85";

export const Recruit = () => {
  const { t } = useLang();

  return (
    <section
      id="reseller"
      className="relative bg-brand-cream-alt py-24 md:py-32 overflow-hidden"
      data-testid="recruit-section"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-center">
          {/* Image Collage */}
          <div className="col-span-12 md:col-span-6 relative h-[500px] md:h-[680px]">
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
              className="absolute top-0 left-0 w-[55%] aspect-[3/4] overflow-hidden"
            >
              <img src={IMG1} alt="" className="w-full h-full object-cover" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
              className="absolute top-[18%] right-0 w-[50%] aspect-square overflow-hidden border-[8px] border-brand-cream-alt"
            >
              <img src={IMG2} alt="" className="w-full h-full object-cover" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
              className="absolute bottom-0 left-[15%] w-[55%] aspect-[4/3] overflow-hidden border-[8px] border-brand-cream-alt"
            >
              <img src={IMG3} alt="" className="w-full h-full object-cover" />
            </motion.div>

            <span className="outline-number-red absolute bottom-2 right-2 text-[8rem] md:text-[12rem] leading-none pointer-events-none select-none opacity-40">
              04
            </span>
          </div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 md:col-span-6 md:pl-8"
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="block w-8 h-px bg-brand-red" />
              <span className="font-sans text-[11px] tracking-[0.3em] uppercase text-brand-red">
                {t.recruit.label}
              </span>
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-brand-ink leading-[1]">
              {t.recruit.headline}
            </h2>
            <p className="mt-8 font-sans text-base md:text-lg text-brand-muted leading-relaxed max-w-lg">
              {t.recruit.body}
            </p>
            <a
              href="#contact"
              className="mt-10 inline-flex items-center gap-3 px-8 py-4 bg-brand-ink text-brand-cream font-sans text-sm tracking-[0.2em] uppercase hover:bg-brand-red transition-colors group"
              data-testid="recruit-cta"
            >
              {t.recruit.cta}
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
